var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#7F8C8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8884 21.6663C16.6374 21.6663 16.4133 21.5229 16.3147 21.2898L15.006 18.3406L14.3606 19.3625C14.244 19.5418 14.0468 19.6583 13.8317 19.6583H12.3167C11.9671 19.6583 11.6892 19.3804 11.6892 19.0308C11.6892 18.6812 11.9671 18.4033 12.3167 18.4033H13.4821L14.5667 16.6912C14.6922 16.494 14.9074 16.3864 15.1404 16.4043C15.3735 16.4223 15.5707 16.5657 15.6693 16.7719L16.8078 19.3356L18.3944 14.7549C18.4841 14.5039 18.7171 14.3336 18.9861 14.3336C19.255 14.3336 19.488 14.5039 19.5777 14.7549L20.9044 18.5109L21.245 17.982C21.3616 17.8027 21.5588 17.6952 21.7739 17.6952H23.6833C24.0329 17.6952 24.3108 17.9731 24.3108 18.3227C24.3108 18.6723 24.0329 18.9502 23.6833 18.9502H22.1145L21.2629 20.2679C21.1374 20.4741 20.9044 20.5816 20.6623 20.5547C20.4203 20.5278 20.2231 20.3665 20.1424 20.1424L18.9861 16.8705L17.4711 21.2539C17.3904 21.496 17.1663 21.6663 16.9064 21.6753C16.9064 21.6663 16.8974 21.6663 16.8884 21.6663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27C13.0339 27 9 22.9572 9 18C9 13.0428 13.0339 9 18 9C22.9661 9 27 13.0339 27 18C27 22.9661 22.9572 27 18 27ZM18 10.1922C13.6972 10.1922 10.1922 13.6972 10.1922 18C10.1922 22.3028 13.6972 25.8078 18 25.8078C22.3028 25.8078 25.8078 22.3028 25.8078 18C25.8078 13.6972 22.3028 10.1922 18 10.1922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/current.af2c0cad.svg";
export { ForwardRef as ReactComponent };